/**
 * Tema claro/escuro.
 *
 * `sistema` é o padrão: sem `data-theme` no `<html>`, o CSS cai na media query
 * e segue a preferência do SO. As duas escolhas explícitas carimbam o atributo,
 * que vence a media query nos dois sentidos — inclusive para forçar claro num
 * sistema escuro, que é o caso de quem vai projetar o painel numa reunião.
 */

import { create } from 'zustand'

export type Tema = 'sistema' | 'claro' | 'escuro'

const CHAVE = 'pricing:tema'

function aplicar(tema: Tema) {
  const raiz = document.documentElement
  if (tema === 'sistema') raiz.removeAttribute('data-theme')
  else raiz.setAttribute('data-theme', tema === 'claro' ? 'light' : 'dark')
}

function inicial(): Tema {
  const guardado = localStorage.getItem(CHAVE)
  return guardado === 'claro' || guardado === 'escuro' ? guardado : 'sistema'
}

type Estado = {
  tema: Tema
  definir: (tema: Tema) => void
}

export const useTema = create<Estado>((set) => ({
  tema: inicial(),
  definir(tema) {
    localStorage.setItem(CHAVE, tema)
    aplicar(tema)
    set({ tema })
  },
}))

aplicar(useTema.getState().tema)
